import { graphql } from 'gatsby';
// import moment from 'moment';
import React, { useEffect, useState } from 'react';
import { EmailShareButton, FacebookShareButton, TwitterShareButton, LinkedinShareButton } from 'react-share';
import Image from '~/components/Dynamic/Image';
import RelatedPosts from '~/components/Dynamic/RelatedPosts';
import RichTextRenderer from '~/components/Dynamic/RichTextRenderer';
import Layout from '~/components/Layout';
import Seo from '~/components/SEO';
import SidebarNewsletterSubscribe from '~/components/SidebarNewsletterSubscribe';
import SocialIcon from '~/components/SocialIcon';
import useStoryblok from '~/utils/storyblok-service';


export default function PostTemplate({ data, location, pageContext }) {
  const story = useStoryblok(data.storyblokEntry, location);
  const title = story?.content?.title || story.name;
  const [pageUrl, setPageUrl] = useState('');

  useEffect(() => {
    setPageUrl(window?.location?.href);
  }, []);

  const ogImage = story?.content?.previewImage?.filename || false;

  const author = Array.isArray(story?.content?.postAuthor)
    ? story?.content?.postAuthor[0]
    : story?.content?.postAuthor;

  return (
    <Layout showHeaderNewsletter locale={pageContext.locale}>
      <Seo {...story.content.seo} og_image={ogImage} title={title} lang={story.lang} pageContext={pageContext} />
      <section className="my-20 mt-12 md:my-28 sm:mt-40 xl:pt-8">
        <div className="container">
          <div className="flex justify-center">
            <div className="flex flex-col max-w-3xl">
              {data.storyblokEntry?.content?.category?.name && (
                <div className="mt-1 font-bold uppercase text-15px">{data.storyblokEntry.content.category.name}</div>
              )}

              <div className="mt-4">
                <h1
                  className={`font-bold leading-tight text-40px font-heading tracking-2`}
                  dangerouslySetInnerHTML={{ __html: title }}
                />
              </div>
              {author && author?.name && (
                <>
                  <div className="flex items-center mt-4 ">
                    {author.content?.image?.filename && (
                      <div className="mr-4 w-11 h-11">
                        <Image blok={author.content?.image} className="object-contain" />
                      </div>
                    )}
                    <div className="font-heading font-extrabold text-15px uppercase tracking-[0.01em] text-[#898982] leading-snug">
                      BY { author.content?.heading || author.name }
                    </div>
                  </div>
                </>
              )}
            </div>
          </div>
          <div className="mt-20">
            <Image blok={story?.content?.hero_image} />
          </div>
        </div>
      </section>

      <section>
        <div className="container my-32">
          <div className="flex flex-wrap">
            <aside className="flex flex-col w-full mb-32 lg:w-3/12 justify-evenly md:block lg:mb-0">
              <div className="bg-beige ">
                <div className="flex flex-col p-6">
                  <SidebarNewsletterSubscribe />
                </div>
              </div>

              <div className="flex flex-col items-center mt-12">
                <div className="text-sh text-14px">{pageContext?.locale?.content?.share}</div>
                <div className="flex mt-4 -ml-3">
                  <div className="pl-3">
                    <FacebookShareButton url={pageUrl}>
                      <SocialIcon />
                    </FacebookShareButton>
                  </div>
                  <div className="pl-3">
                    <TwitterShareButton url={pageUrl} title={title}>
                      <SocialIcon type="twitter" />
                    </TwitterShareButton>
                  </div>
                  <div className="pl-3">
                    <EmailShareButton url={pageUrl} title={title}>
                      <SocialIcon type="mail" />
                    </EmailShareButton>
                  </div>
                  <div className="pl-3">
                    <LinkedinShareButton url={pageUrl} title={title}>
                      <SocialIcon type="linkedin" />
                    </LinkedinShareButton>
                  </div>
                </div>
              </div>
            </aside>
            <div className="w-full lg:w-9/12">
              <div className="mx-auto max-w-588">
                <RichTextRenderer content={story.content.long_text} />
              </div>

              {/* <div className="flex justify-center" style={{ display: 'none' }}>
                <div className="flex flex-col items-center max-w-588">
                  <div className="max-w-588">
                    <h3 className="mb-4 font-bold text-38px tracking-2 font-heading ">Heading 1</h3>
                    <div className="leading-snug tracking-tighter prose text-black text-24px opacity-70">
                      <p>
                        Nulla vitae elit libero, a pharetra augue. Cras mattis consectetur purus sit amet fermentum
                        vestibul umligula porta felis euismod semper maecenas.
                      </p>
                    </div>
                  </div>
                  <div className="mt-16 max-w-588">
                    <h3 className="mb-4 font-bold text-28px tracking-2 font-heading ">Heading 2</h3>
                    <div className="leading-normal tracking-tighter prose text-black text-17px opacity-70">
                      <p>
                        Nulla vitae elit libero, a pharetra augue. Cras mattis consectetur purus sit amet fermentum.
                        Vestibulum id ligula porta felis euismod semper. Maecenas sed diam eget risus varius blandit sit
                        amet non magna. Cras justo odio, dapibus ac facilisis in, egestas eget quam. Fusce dapibus,
                        tellus ac cursus commodo, tortor mauris condimentum nibh, ut fermentum massa justo sit amet
                        risus. Morbi leo risus, porta ac consectetur ac, vestibulum at eros. Fusce dapibus, tellus ac
                        cursus commodo, tortor mauris condimentum nibh, ut fermentum massa justo sit amet risus. Etiam
                        porta sem malesuada magna mollis euismod. Maecenas sed diam eget risus varius blandit sit amet
                        non magna. Maecenas faucibus. Nulla vitae elit libero, a pharetra augue. Cras mattis consectetur
                        purus sit amet fermentum. Vestibulum id ligula porta felis euismod semper. Maecenas sed diam
                        eget risus varius blandit sit amet non magna. Cras justo odio, dapibus ac facilisis in, egestas
                        eget quam.
                      </p>
                    </div>
                  </div>

                  <div className="max-w-2xl mt-16 rounded-xl">
                    <StaticImage
                      src={`../assets/images/customer-post/video-placeholder.jpg`}
                      className="shadow-md rounded-xl"
                      alt=""
                    />
                  </div>

                  <div className="mt-20 max-w-588">
                    <div>
                      <p className="leading-normal tracking-tighter prose text-black text-17px opacity-70">
                        Nulla vitae elit libero, a pharetra augue. Cras mattis consectetur purus sit amet fermentum.
                        Vestibulum id ligula porta felis euismod semper. Maecenas sed diam eget risus varius blandit sit
                        amet non magna. Cras justo odio, dapibus ac facilisis in, egestas eget quam.{' '}
                      </p>
                    </div>

                    <div className="mt-12">
                      <div className="border-t"></div>
                      <div className="font-bold leading-normal tracking-tighter text-20px py-9">
                        <p>
                          Nulla vitae elit libero, a pharetra augue. Cras mattis consectetur purus sit amet fermentum.
                          Vestibulum id ligula porta felis euismod semper. Maecenas sed diam eget risus varius.
                        </p>
                      </div>
                      <div className="border-t"></div>
                    </div>

                    <div className="mt-16">
                      <div className="font-semibold icon-list text-15px">
                        <ul>
                          <li>Start with 1 user</li>
                          <li>Start with 1 user</li>
                          <li>Start with 1 user</li>
                          <li>Start with 1 user</li>
                        </ul>
                      </div>
                    </div>
                  </div>
                  <div className="max-w-xl mt-16">
                    <div>
                      <StaticImage src={`../assets/images/customer-post/customer-post-place.jpg`} alt="" />
                    </div>
                    <div className="flex justify-center mt-4 font-bold leading-snug tracking-tighter uppercase opacity-60 text-14px">
                      <p>Nulla vitae elitlibero a pharetra augue crasmattis consectetuR</p>
                    </div>
                  </div>

                  <div className="mt-16 max-w-588">
                    <h3 className="mb-4 font-extrabold text-28px tracking-2 font-heading ">Heading 2</h3>
                    <div className="leading-normal tracking-tighter prose text-black text-17px opacity-70">
                      <p>
                        Nulla vitae elit libero, a pharetra augue. Cras mattis consectetur purus sit amet fermentum.
                        Vestibulum id ligula porta felis euismod semper. Maecenas sed diam eget risus varius blandit sit
                        amet non magna. Cras justo odio, dapibus ac facilisis in, egestas eget quam. Fusce dapibus,
                        tellus ac cursus commodo, tortor mauris condimentum nibh, ut fermentum massa justo sit amet
                        risus. Morbi leo risus, porta ac consectetur ac, vestibulum at eros. Fusce dapibus, tellus ac
                        cursus commodo, tortor mauris condimentum nibh, ut fermentum massa justo sit amet risus. Etiam
                        porta sem malesuada magna mollis euismod. Maecenas sed diam eget risus varius blandit sit amet
                        non magna. Maecenas faucibus. Nulla vitae elit libero, a pharetra augue. Cras mattis consectetur
                        purus sit amet fermentum. Vestibulum id ligula porta felis euismod semper. Maecenas sed diam
                        eget risus varius blandit sit amet non magna. Cras justo odio, dapibus ac facilisis in, egestas
                        eget quam.
                      </p>
                    </div>
                  </div>

                  <div className="my-24 bg-beige">
                    <div className="flex flex-col px-12 py-16">
                      <div className="flex justify-between">
                        <div className="max-w-[250px]">
                          <StaticImage src={`../assets/images/articles/articles-test.png`} alt="" />
                        </div>

                        <div>
                          <StaticImage src={`../assets/icons/deliveroo.svg`} placeholder="tracedSVG" alt="" />
                        </div>
                      </div>
                      <div className="flex justify-center ">
                        <div className="flex flex-col mt-12">
                          <div>
                            <h4 className="text-28px leading-[1.32em] font-heading mt-8 md:mt-0">
                              “BOOM makes everything easier, cheaper, faster. If it wasn’t for BOOM I’d still have to
                              invest in marketing!”
                            </h4>
                          </div>
                          <div className="flex flex-col justify-between mt-10 md:flex-row">
                            <div>
                              <h4 className="mt-6 font-extrabold uppercase text-16px font-heading md:mt-0 ">
                                JAMES SMITH
                              </h4>
                              <div className="italic font-bold">
                                <p>Head of operation, Company Name</p>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="leading-normal tracking-tighter prose text-black max-w-588 text-17px opacity-70">
                    <p>
                      Nulla vitae elit libero, a pharetra augue. Cras mattis consectetur purus sit amet fermentum.
                      Vestibulum id ligula porta felis euismod semper. Maecenas sed diam eget risus varius blandit sit
                      amet non magna. Cras justo odio, dapibus ac facilisis in, egestas eget quam. Fusce dapibus, tellus
                      ac cursus commodo, tortor mauris condimentum nibh, ut fermentum massa justo sit amet risus. Morbi
                      leo risus, porta ac consectetur ac, vestibulum at eros. Fusce dapibus, tellus ac cursus commodo,
                      tortor mauris condimentum nibh.
                    </p>
                  </div>

                  <div className="max-w-2xl my-16">
                    <div>
                      <StaticImage src={`../assets/images/customer-post/post-grey-place.jpg`} alt="" />
                    </div>
                  </div>

                  <div className="leading-normal tracking-tighter prose text-black max-w-588 text-17px opacity-70">
                    <p>
                      Nulla vitae elit libero, a pharetra augue. Cras mattis consectetur purus sit amet fermentum.
                      Vestibulum id ligula porta felis euismod semper. Maecenas sed diam eget risus varius blandit sit
                      amet non magna. Cras justo odio, dapibus ac facilisis in, egestas eget quam.
                    </p>
                  </div>

                  <div className="my-16 border-l-4 bg-light-grey border-blue max-w-588">
                    <div className="px-16 py-11">
                      <h4 className="font-bold text-22px font-heading tracking-[-0.01em] leading-snug">
                        “BOOM makes everything easier, cheaper, faster. If it wasn’t for BOOM I’d still have to invest
                        in marketing!”
                      </h4>
                    </div>
                  </div>

                  <div className="mt-16 max-w-588">
                    <h3 className="mb-4 font-bold text-28px tracking-2 font-heading ">Heading 2</h3>
                    <div className="leading-normal tracking-tighter prose text-black text-17px opacity-70">
                      <p>
                        Nulla vitae elit libero, a pharetra augue. Cras mattis consectetur purus sit amet fermentum.
                        Vestibulum id ligula porta felis euismod semper. Maecenas sed diam eget risus varius blandit sit
                        amet non magna. Cras justo odio, dapibus ac facilisis in, egestas eget quam. Fusce dapibus,
                        tellus ac cursus commodo, tortor mauris condimentum nibh, ut fermentum massa justo sit amet
                        risus. Morbi leo risus, porta ac consectetur ac, vestibulum at eros. Fusce dapibus, tellus ac
                        cursus commodo, tortor mauris condimentum nibh, ut fermentum massa justo sit amet risus. Etiam
                        porta sem malesuada magna mollis euismod. Maecenas sed diam eget risus varius blandit sit amet
                        non magna. Maecenas faucibus. Nulla vitae elit libero, a pharetra augue. Cras mattis consectetur
                        purus sit amet fermentum. Vestibulum id ligula porta felis euismod semper. Maecenas sed diam
                        eget risus varius blandit sit amet non magna. Cras justo odio, dapibus ac facilisis in, egestas
                        eget quam.
                      </p>
                    </div>
                  </div>

                  <div className="my-16 text-white bg-black max-w-588">
                    <div className="flex flex-col p-20">
                      <div className="font-bold leading-snug tracking-tight uppercase text-15px">title</div>
                      <div className="mt-5 font-normal leading-normal tracking-tighter prose text-17px opacity-70">
                        <p>
                          Nulla vitae elit libero, a pharetra augue. Cras mattis consectetur purus sit amet fermentum.
                          Vestibulum id ligula porta felis euismod semper. Maecenas sed diam eget risus varius blandit
                          sit amet non magna. Cras justo odio, dapibus ac facilisis in.
                        </p>
                      </div>
                      <div className="mt-12 font-semibold square-list--blue text-15px">
                        <ul>
                          <li>Start with 1 user</li>
                          <li>Start with 1 user</li>
                          <li>Start with 1 user</li>
                          <li>Start with 1 user</li>
                        </ul>
                      </div>
                    </div>
                  </div>

                  <div className="flex self-start">
                    <div className="flex flex-col">
                      <div className="font-semibold text-14px tracking-2 opacity-70">Tags</div>
                      <div className="mt-5 font-medium underline text-16px" style={{ color: '#898982' }}>
                        <ul>
                          <li>Customer Experience</li>
                          <li>Customer Stories</li>
                          <li>Ecommerce</li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
              </div> */}
            </div>
          </div>
        </div>
      </section>

      {story?.content?.relatedPosts?.length > 0 && (
        <>
          <div className="container border-t border-black my-28 opacity-10"></div>
          <RelatedPosts posts={story?.content?.relatedPosts} />
        </>
      )}
    </Layout>
  );
}

export const query = graphql`
  query PostQuery($id: String!) {
    storyblokEntry(id: { eq: $id }) {
      id
      name
      content
      lang
      slug
      uuid
      full_slug
    }
  }
`;
